import React, { useEffect, useRef } from "react";

const Cursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    let rx = 0, ry = 0, tx = 0, ty = 0, raf;
    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      if (dot.current) {
        dot.current.style.left = `${tx}px`;
        dot.current.style.top = `${ty}px`;
      }
    };
    const loop = () => {
      rx += (tx - rx) * 0.15;
      ry += (ty - ry) * 0.15;
      if (ring.current) {
        ring.current.style.left = `${rx}px`;
        ring.current.style.top = `${ry}px`;
      }
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => {
      if (e.target.closest("a,button,[data-cursor-hover]") && ring.current) {
        ring.current.style.width = "64px";
        ring.current.style.height = "64px";
        ring.current.style.backgroundColor = "rgba(212,175,55,0.12)";
      }
    };
    const out = () => {
      if (ring.current) {
        ring.current.style.width = "40px";
        ring.current.style.height = "40px";
        ring.current.style.backgroundColor = "transparent";
      }
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    window.addEventListener("mouseout", out);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mouseout", out);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dot} className="cursor-dot" />
      <div ref={ring} className="cursor-ring" />
    </>
  );
};

export default Cursor;
